export interface BusinessFact {
  label: string;
  value: string;
}

export const BUSINESS = {
  tradingName: 'Victor Chanet Software, Retail and Consulting',
  soleTrader: 'Victor Chanet',
  street: 'ul. Marcina Kasprzaka 31/119',
  postTown: '01-234 Warszawa',
  country: 'Poland',
  taxNumber: '9512645271',
  statisticalNumber: '544392504',
  register: 'CEIDG, the Polish register of sole traders',
  tradingSince: '30 March 2026',
  email: 'hello@goodbuild.cc',
} as const;

export const POSTAL_ADDRESS = [BUSINESS.street, BUSINESS.postTown, BUSINESS.country].join('\n');

export const BUSINESS_FACTS: readonly BusinessFact[] = [
  { label: 'Business', value: BUSINESS.tradingName },
  { label: 'Run by', value: BUSINESS.soleTrader },
  { label: 'Address', value: POSTAL_ADDRESS },
  { label: 'NIP', value: BUSINESS.taxNumber },
  { label: 'REGON', value: BUSINESS.statisticalNumber },
  { label: 'Registered in', value: BUSINESS.register },
  { label: 'Trading since', value: BUSINESS.tradingSince },
];

export const LEGAL_UPDATED = '9 September 2026';
